<template>
	<b-modal
		ref="free-chick-cintillos-modal"
		size="lg"
		:title="`ASIGNAR CINTILLO A POLLO ${chick.correlative}`"
		hide-footer
		@hidden="$emit('close')"
		scrollable
	>
		<b-overlay :show="isLoading">
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>

			<b-row class="mb-1">
				<b-col cols="12" xl="4" class="d-flex align-items-center justify-content-start">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="8">
					<div class="d-flex align-items-center justify-content-center">
						<v-select
							label="description"
							class="mx-1"
							:options="colorOptions"
							:reduce="(opt) => opt.id"
							style="width: 220px"
							v-model="selectedColor1"
							placeholder="Seleccionar color #1"
						>
							<template #option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
							<template #selected-option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
						</v-select>
						<v-select
							label="description"
							class="mx-1"
							:options="colorOptions"
							style="width: 220px"
							:reduce="(opt) => opt.id"
							v-model="selectedColor2"
							placeholder="Seleccionar color #2"
						>
							<template #option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
							<template #selected-option="option">
								<div class="d-flex align-items-center justify-content-between">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
						</v-select>
					</div>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">{{ field.label }}</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="cintillos.length > 0">
						<b-tr v-for="(cintillo, index) in cintillos" :key="index">
							<b-td class="text-center">
								<CombChickenlegsCintillos
									:postura="{
										id: cintillo.id,
										chickenleg_wich_leg: cintillo.chickenleg_wich_leg,
										chickenleg_qty_cintillos: cintillo.qty_cintillos,
										cintillo_color: cintillo.hex_1,
										cintillo_description: cintillo.description_1,
										second_color_color: cintillo.hex_2,
										second_color_description: cintillo.description_2,
										total_minus_infertile_eggs: 1,
									}"
									:chickenleg_wich_leg="1"
								/>
							</b-td>
							<b-td class="text-center">
								<CombChickenlegsCintillos
									:postura="{
										id: cintillo.id,
										chickenleg_wich_leg: cintillo.chickenleg_wich_leg,
										chickenleg_qty_cintillos: cintillo.qty_cintillos,
										cintillo_color: cintillo.hex_1,
										cintillo_description: cintillo.description_1,
										second_color_color: cintillo.hex_2,
										second_color_description: cintillo.description_2,
										total_minus_infertile_eggs: 1,
									}"
									:chickenleg_wich_leg="2"
								/>
							</b-td>
							<b-td class="text-center">
								<b-button variant="outline-primary" size="sm" @click="assignToChicks(cintillo.id)">
									<feather-icon icon="PlusIcon" size="16" />
								</b-button>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="cintillos.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import chicksService from "@/services/encaste/chicks.service"
import CombChickenlegsCintillos from "@/views/amg/encaste/lotes/components/CombChickenlegsCintillos.vue"
import lotesService from "@/services/lotes.service.js"
export default {
	name: "FreeChickCintillosModal",
	components: { CombChickenlegsCintillos },
	props: {
		chick: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		search: "",
		isLoading: false,
		fields: [
			{ key: "left", label: "PATA IZQUIERDA", class: "text-center" },
			{ key: "right", label: "PATA DERECHA", class: "text-center" },
			{ key: "select", label: "ACCIÓN", class: "text-center" },
		],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		cintillos: [],
		colorOptions: [],
		selectedColor1: null,
		selectedColor2: null,
	}),
	methods: {
		async getActiveColors() {
			const { data } = await lotesService.getActiveColors()
			this.colorOptions = data
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				const { data } = await chicksService.getChickCintillosFree({
					per_page: this.pagination.perPage,
					page: page,
					cintillo_id: this.chick.cintillo_pata_brother_id,
					colorId1: this.selectedColor1,
					colorId2: this.selectedColor2,
				})
				this.cintillos = data.data || []
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.error("Error fetching average weights report cintillos:", error)
			} finally {
				this.isLoading = false
			}
		},
		async assignToChicks(cintilloId) {
			try {
				const { isConfirmed } = await this.showConfirmSwal({
					title: "Asignar Cintillo",
					text: `¿Estás seguro de que deseas asignar este cintillo al pollo ${this.chick.correlative}?`,
				})
				if (!isConfirmed) return
				await chicksService.assignToChicks({
					chick_id: this.chick.id,
					cintillo_pata_id: cintilloId,
				})
				this.$emit("refresh")
				this.$emit("close")
				this.showSuccessToast("Cintillo asignado correctamente")
			} catch (error) {
				console.error("Error assigning cintillo to chick:", error)
			}
		},
	},
	watch: {
		selectedColor1() {
			this.getRows()
		},
		selectedColor2() {
			this.getRows()
		},
		"pagination.curPage": async function () {
			await this.getRows(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getRows()
		},
	},
	async mounted() {
		this.getActiveColors()
		this.getRows()
		this.$refs["free-chick-cintillos-modal"].toggle()
	},
}
</script>
